import { IRevenueSnapshot } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

import { REVENUE_TYPES } from '../../../enums/REVENUE_TYPES'

interface IGetRevenueValueByType {
  item: IRevenueSnapshot
  revenueType: REVENUE_TYPES
  field: string
}
export const getRevenueValueByType = ({ item, field, revenueType }: IGetRevenueValueByType) => {
  if (revenueType === REVENUE_TYPES.SellThru) {
    return item[field]
  }
  return item[field + 'SellTo']
}
